export default __webpack_public_path__ + "static/media/keyboard_voice.d02831c7.svg";